exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media only screen and (max-width: 1179px) {\n.notificationContainerWrapper[data-v-733dabd8] {\n        padding-left: 15px;\n        padding-right: 15px;\n}\n}\n", ""]);

// exports
